import React, { useState, useEffect } from 'react';
import { operatorsAPI } from '../services/api';
import { FiPlus, FiEdit2, FiTrash2, FiUser, FiPhone, FiX } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { formatDuration } from '../utils/formatters';
import RatingStars from '../components/RatingStars';

const PERIODS = [
  { key: 'week', label: '7 kun' },
  { key: 'month', label: '30 kun' },
  { key: 'year', label: 'Yil' },
];

export default function OperatorsPage() {
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingOp, setEditingOp] = useState(null);
  // Ko'rsatkichlar operator id si bo'yicha. Ilgari bu sahifada faqat ism/login
  // bor edi — "qancha gaplashgan, qanday baho olgan" degan savolga javob yo'q edi.
  const [stats, setStats] = useState({});
  const [period, setPeriod] = useState('month');

  const load = async () => {
    setLoading(true);
    try {
      // Ikkalasi ALOHIDA himoyalangan: ko'rsatkichlar kelmasa ham ro'yxat ko'rinadi.
      const [listRes, prodRes] = await Promise.all([
        operatorsAPI.list(),
        operatorsAPI.productivity({ period }).catch(() => null),
      ]);
      setOperators(listRes.data.operators || listRes.data || []);
      const map = {};
      ((prodRes && prodRes.data.operators) || []).forEach((o) => { map[o.id] = o; });
      setStats(map);
    } catch (err) {
      toast.error("Operatorlarni olishda xato");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [period]);

  const openCreate = () => {
    setEditingOp(null);
    setModalOpen(true);
  };

  const openEdit = (op) => {
    setEditingOp(op);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingOp(null);
  };

  const handleSave = async (data) => {
    try {
      if (editingOp) {
        await operatorsAPI.update(editingOp.id, data);
        toast.success("Yangilandi");
      } else {
        await operatorsAPI.create(data);
        toast.success("Qo'shildi");
      }
      closeModal();
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || "Xatolik");
    }
  };

  const handleDelete = async (op) => {
    if (!window.confirm(`"${op.full_name}" operatorini o'chirmoqchimisiz?`)) return;
    try {
      await operatorsAPI.delete(op.id);
      toast.success("O'chirildi");
      load();
    } catch (err) {
      toast.error("O'chirishda xato");
    }
  };

  const getStatusLabel = (s) => s === 'online' ? 'Onlayn' : s === 'break' ? 'Tanaffus' : 'Oflayn';
  const getStatusColor = (s) => s === 'online' ? '#10b981' : s === 'break' ? '#f59e0b' : '#6b7280';

  return (
    <div>
      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 700, margin: 0 }}>Operatorlar</h2>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
              Jami: {operators.length} ta operator
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            {/* Ko'rsatkichlar qaysi davr uchun ekani ANIQ ko'rinib tursin */}
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Ko'rsatkichlar:</span>
            <div style={{ display: 'flex', gap: 6 }}>
              {PERIODS.map((p) => (
                <button
                  key={p.key}
                  onClick={() => setPeriod(p.key)}
                  style={{
                    padding: '5px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                    cursor: 'pointer', fontFamily: 'inherit',
                    border: '1px solid ' + (period === p.key ? 'var(--accent, #3b82f6)' : 'var(--border)'),
                    background: period === p.key ? 'var(--accent-light, rgba(59,130,246,0.15))' : 'transparent',
                    color: period === p.key ? 'var(--accent, #3b82f6)' : 'var(--text-secondary)',
                  }}
                >
                  {p.label}
                </button>
              ))}
            </div>
            <button className="btn btn-primary" onClick={openCreate}>
              <FiPlus size={16} /> Yangi operator
            </button>
          </div>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? (
          <div className="loading-center"><div className="spinner" /></div>
        ) : operators.length === 0 ? (
          <div style={{ padding: 60, textAlign: 'center', color: 'var(--text-muted)' }}>
            Hali operatorlar yo'q
          </div>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Ism</th>
                  <th>Login</th>
                  <th>Extension</th>
                  <th>Holat</th>
                  <th style={{ textAlign: 'center' }}>Javob berdi</th>
                  <th>Jami gaplashish</th>
                  <th style={{ textAlign: 'center' }}>Baho (CSAT)</th>
                  <th style={{ width: 100 }}>Amallar</th>
                </tr>
              </thead>
              <tbody>
                {operators.map(op => (
                  <tr key={op.id}>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{
                          width: 36, height: 36, borderRadius: '50%',
                          background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: 'white', fontSize: 13, fontWeight: 700,
                        }}>
                          {op.full_name?.[0]?.toUpperCase() || 'O'}
                        </div>
                        <span style={{ fontWeight: 600 }}>{op.full_name}</span>
                      </div>
                    </td>
                    <td style={{ fontFamily: 'monospace' }}>{op.username}</td>
                    <td style={{ fontWeight: 600 }}>#{op.sip_extension}</td>
                    <td>
                      <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                        padding: '4px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600,
                        background: `${getStatusColor(op.status)}22`,
                        color: getStatusColor(op.status),
                      }}>
                        <span style={{
                          width: 6, height: 6, borderRadius: '50%',
                          background: getStatusColor(op.status),
                        }} />
                        {getStatusLabel(op.status)}
                      </span>
                    </td>
                    <td style={{ textAlign: 'center', fontWeight: 600 }}>
                      {stats[op.id] ? stats[op.id].answered_count : '—'}
                    </td>
                    <td style={{ fontWeight: 600 }}>
                      {stats[op.id] ? formatDuration(stats[op.id].total_talk_time || 0) : '—'}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {stats[op.id] && stats[op.id].rated_count > 0 ? (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <RatingStars value={stats[op.id].avg_rating} />
                          <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>({stats[op.id].rated_count})</span>
                        </span>
                      ) : <span style={{ color: 'var(--text-muted)' }}>—</span>}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button className="btn btn-ghost btn-icon" onClick={() => openEdit(op)} title="Tahrirlash">
                          <FiEdit2 size={14} />
                        </button>
                        <button className="btn btn-ghost btn-icon" onClick={() => handleDelete(op)} title="O'chirish" style={{ color: '#ef4444' }}>
                          <FiTrash2 size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modalOpen && (
        <OperatorModal
          operator={editingOp}
          onClose={closeModal}
          onSave={handleSave}
        />
      )}
    </div>
  );
}

function OperatorModal({ operator, onClose, onSave }) {
  const [form, setForm] = useState({
    full_name: operator?.full_name || '',
    username: operator?.username || '',
    password: '',
    sip_extension: operator?.sip_extension || '',
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.full_name || !form.username || !form.sip_extension) {
      toast.error("Ism, login va extension majburiy");
      return;
    }
    if (!operator && !form.password) {
      toast.error("Yangi operator uchun parol majburiy");
      return;
    }
    setSaving(true);
    
    const data = {...form};
    if (operator && !data.password) delete data.password;  // parol bo'sh bo'lsa, o'zgartirmaymiz
    
    await onSave(data);
    setSaving(false);
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>
            {operator ? 'Operatorni tahrirlash' : 'Yangi operator'}
          </h3>
          <button onClick={onClose} style={styles.closeBtn}><FiX size={18} /></button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}><FiUser size={14} /> To'liq ismi *</label>
            <input
              type="text" required
              value={form.full_name}
              onChange={(e) => setForm({ ...form, full_name: e.target.value })}
              style={styles.input}
              autoFocus
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Login *</label>
            <input
              type="text" required
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              style={styles.input}
              disabled={!!operator}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}><FiPhone size={14} /> Extension *</label>
            <input
              type="text" required
              value={form.sip_extension}
              onChange={(e) => setForm({ ...form, sip_extension: e.target.value })}
              style={styles.input}
              placeholder="100"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>
              Parol {operator ? '(bo\'sh qoldirsangiz, o\'zgarmaydi)' : '*'}
            </label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              style={styles.input}
              required={!operator}
            />
          </div>

          <div style={styles.footer}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Bekor qilish
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saqlanmoqda..." : operator ? "Yangilash" : "Qo'shish"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, backdropFilter: 'blur(4px)',
  },
  modal: {
    background: '#1e293b', border: '1px solid #2d3a4f',
    borderRadius: 16, padding: 24, width: '100%', maxWidth: 480,
    maxHeight: '90vh', overflow: 'auto',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: 20,
  },
  closeBtn: {
    background: 'transparent', border: 'none', color: 'var(--text-muted)',
    cursor: 'pointer', padding: 4,
  },
  formGroup: { marginBottom: 16 },
  label: {
    display: 'flex', alignItems: 'center', gap: 6,
    fontSize: 13, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6,
  },
  input: {
    width: '100%', padding: '10px 12px',
    background: '#0f172a', border: '1px solid #2d3a4f',
    borderRadius: 8, color: '#f1f5f9',
    fontSize: 14, outline: 'none', fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  footer: {
    display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24,
  },
};
